
export default class Interval {
  constructor (min, max) {
    this.min = parseFloat(min);
    this.max = parseFloat(max);
  }

  isDecreasing () {
    return this.min > this.max;
  }

  isIncreasing () {
    return this.max > this.min;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/geometry/Interval.js